import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import {
  faChartMixed,
  faEllipsis,
  faEnvelopeOpenText,
  faGrid2,
  faRectangleAd,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { NavItem } from '@feathr/components';
import { useAccount, useFlags, useLocalUrl } from '@feathr/extender/state';

import TertiaryNav from '../../TertiaryNav';

function EventMarketingNav(): JSX.Element {
  const localUrl = useLocalUrl();
  const account = useAccount();
  const { eventId } = useParams<{ eventId: string }>();
  const { t } = useTranslation();
  const flags = useFlags();

  const showGoogleAds = flags.hasGoogleAds;

  return (
    <TertiaryNav label={t('Marketing navigation')}>
      <NavItem
        icon={<FontAwesomeIcon icon={faGrid2} />}
        to={localUrl(`/projects/${eventId}/campaigns/all`)}
      >
        {t('All')}
      </NavItem>
      <NavItem
        icon={<FontAwesomeIcon icon={faRectangleAd} />}
        to={localUrl(`/projects/${eventId}/campaigns/ads`)}
      >
        {t('Ads')}
      </NavItem>
      <NavItem
        icon={<FontAwesomeIcon icon={faEnvelopeOpenText} />}
        to={localUrl(`/projects/${eventId}/campaigns/email`)}
      >
        {t('Email')}
      </NavItem>
      {showGoogleAds && (
        <NavItem
          icon={<FontAwesomeIcon icon={faGoogle} />}
          to={localUrl(`/projects/${eventId}/campaigns/google-ads`)}
        >
          {t('Google Ads')}
        </NavItem>
      )}
      {account.hasMonetization && (
        <NavItem
          icon={<FontAwesomeIcon icon={faChartMixed} />}
          to={localUrl(`/projects/${eventId}/campaigns/monetization`)}
        >
          {t('Monetization')}
        </NavItem>
      )}
      <NavItem
        icon={<FontAwesomeIcon icon={faEllipsis} />}
        to={localUrl(`/projects/${eventId}/campaigns/other`)}
      >
        {t('Other')}
      </NavItem>
    </TertiaryNav>
  );
}

export default EventMarketingNav;
